export const OWNERSHIP_STATUS_ANNOTATION = 'tomtom.com/ownership-status';
